import { Phone } from "lucide-react";
import { cn } from "@/lib/utils";
import { initialsOf } from "./whatsapp-display";

/** Initials in a circle; a phone when all we have is a number. */
export function ContactAvatar({ name, className }: { name: string; className?: string }) {
  const initials = initialsOf(name);
  return (
    <span
      aria-hidden="true"
      className={cn(
        "flex size-9 shrink-0 items-center justify-center rounded-full bg-secondary text-xs font-semibold text-secondary-foreground",
        className,
      )}
    >
      {initials ?? <Phone className="size-4 text-muted-foreground" />}
    </span>
  );
}
